export const setWindowTitle = (title: string) => {
  setTimeout(() => {
    window.document.title = `${title} | Shaarp`;
  }, 500);
};

export const resetWindowTitle = () => {
  window.document.title = "Shaarp";
};
